import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
render(<HelmetProvider data-id="element-1171">
    <App data-id="element-1172" />
  </HelmetProvider>, document.getElementById('root'));